define(['app'], function (app) {
    app.filter('tablerIcon', function () {
        var icons = {
            account_circle: 'user-circle',
            account_tree: 'sitemap',
            add: 'plus',
            add_box: 'square-plus',
            add_circle: 'circle-plus',
            add_circle_outline: 'circle-plus',
            add_task: 'list-check',
            all_inbox: 'inbox',
            api: 'api',
            arrow_back: 'arrow-left',
            arrow_drop_down: 'chevron-down',
            arrow_drop_down_circle: 'circle-chevron-down',
            arrow_forward: 'arrow-right',
            arrow_right: 'arrow-right',
            arrow_upward: 'arrow-up',
            article: 'article',
            aspect_ratio: 'aspect-ratio',
            attach_file: 'paperclip',
            auto_awesome: 'sparkles',
            auto_fix_high: 'wand',
            autorenew: 'refresh',
            block: 'ban',
            bookmark: 'bookmark',
            calendar_today: 'calendar',
            card_giftcard: 'gift',
            card_membership: 'id-badge',
            chat: 'message-circle',
            chat_bubble_outline: 'message-circle',
            check: 'check',
            check_circle: 'circle-check',
            check_circle_outline: 'circle-check',
            chevron_right: 'chevron-right',
            clear: 'x',
            close: 'x',
            cloud_download: 'cloud-download',
            code: 'code',
            comment: 'message-circle',
            create_new_folder: 'folder-plus',
            data_usage: 'chart-pie',
            delete_outline: 'trash',
            description: 'file-text',
            done: 'circle-check',
            donut_large: 'chart-donut',
            download: 'download',
            drag_indicator: 'grip-vertical',
            edit: 'pencil',
            email: 'mail',
            error: 'alert-circle',
            error_outline: 'alert-circle',
            expand_less: 'chevron-up',
            expand_more: 'chevron-down',
            file_download: 'download',
            file_present: 'file',
            file_upload: 'upload',
            filter: 'filter',
            filter_list: 'filter',
            first_page: 'chevrons-left',
            folder: 'folder',
            format_quote: 'quote',
            format_shapes: 'shape',
            group_add: 'user-plus',
            headset_mic: 'headphones',
            help_outline: 'help-circle',
            history_edu: 'history',
            info: 'info-circle',
            info_outline: 'info-circle',
            insert_chart: 'chart-bar',
            insights: 'chart-line',
            keyboard_arrow_left: 'chevron-left',
            keyboard_arrow_right: 'chevron-right',
            last_page: 'chevrons-right',
            layers: 'stack',
            lightbulb: 'bulb',
            link: 'link',
            link_off: 'unlink',
            list: 'list',
            live_help: 'help-circle',
            local_library: 'books',
            local_police: 'shield-check',
            lock: 'lock',
            lock_open: 'lock-open',
            logout: 'logout',
            loyalty: 'heart',
            mail_outline: 'mail',
            mark_chat_unread: 'message-circle',
            mark_email_read: 'mail-opened',
            menu_book: 'book',
            mode_edit: 'pencil',
            more_horiz: 'dots',
            navigate_before: 'chevron-left',
            navigate_next: 'chevron-right',
            not_interested: 'ban',
            notes: 'notes',
            open_in_new: 'external-link',
            photo_filter: 'photo',
            picture_as_pdf: 'file-type-pdf',
            pie_chart_outlined: 'chart-pie',
            play_circle_outline: 'player-play',
            preview: 'photo',
            push_pin: 'pin',
            refresh: 'refresh',
            remove: 'minus',
            remove_circle: 'circle-minus',
            remove_circle_outline: 'circle-minus',
            replay: 'rotate-clockwise',
            report_problem: 'alert-triangle',
            search: 'search',
            settings: 'settings',
            share: 'share',
            short_text: 'align-left',
            show_chart: 'chart-line',
            speed: 'gauge',
            star: 'star',
            stop_circle: 'circle-minus',
            subdirectory_arrow_left: 'corner-up-left',
            subscriptions: 'repeat',
            summarize: 'file-text',
            sync: 'refresh',
            text_format: 'typography',
            text_snippet: 'file-text',
            thumb_down: 'thumb-down',
            thumb_up: 'thumb-up',
            thumb_up_alt: 'thumb-up',
            timer: 'clock',
            title: 'heading',
            translate: 'language',
            turned_in: 'bookmark',
            turned_in_not: 'bookmark',
            upload: 'upload',
            verified_user: 'shield-check',
            visibility: 'eye',
            visibility_off: 'eye-off',
            warning: 'alert-triangle',
            warning_amber: 'alert-triangle',
            web: 'world',
            workspaces: 'layout-grid',
            workspaces_outline: 'layout-grid',
            zoom_in: 'zoom-in'
        };

        return function (value) {
            var icon = String(value || '').trim();
            if (!icon) return '';
            if (icon.indexOf('ti ') === 0) return icon.slice(3);
            if (icon.indexOf('ti-') === 0 || icon.indexOf('icon-') === 0) return icon;
            return icons[icon] ? 'ti-' + icons[icon] : 'ti-help-circle';
        };
    });
});
